import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const MultiSelect = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5118 2.75054C14.2011 2.47653 13.7272 2.50622 13.4532 2.81685C13.1792 3.12748 13.2089 3.60142 13.5195 3.87543L15.0039 5.18482C15.2874 5.43489 15.7126 5.43489 15.9961 5.18482L17.4805 3.87543C17.7911 3.60142 17.8208 3.12748 17.5468 2.81685C17.2728 2.50622 16.7989 2.47653 16.4882 2.75054L15.5 3.62227L14.5118 2.75054ZM14.5118 8.81499C14.2011 8.54099 13.7272 8.57067 13.4532 8.8813C13.1792 9.19193 13.2089 9.66588 13.5195 9.93989L15.0039 11.2493C15.2874 11.4993 15.7126 11.4993 15.9961 11.2493L17.4805 9.93989C17.7911 9.66588 17.8208 9.19193 17.5468 8.8813C17.2728 8.57067 16.7989 8.54099 16.4882 8.81499L15.5 9.68673L14.5118 8.81499ZM13.4532 14.8813C13.7272 14.5707 14.2011 14.541 14.5118 14.815L15.5 15.6867L16.4882 14.815C16.7989 14.541 17.2728 14.5707 17.5468 14.8813C17.8208 15.1919 17.7911 15.6659 17.4805 15.9399L15.9961 17.2493C15.7126 17.4993 15.2874 17.4993 15.0039 17.2493L13.5195 15.9399C13.2089 15.6659 13.1792 15.1919 13.4532 14.8813ZM3.01562 3.28223C2.60141 3.28223 2.26562 3.61801 2.26562 4.03223C2.26562 4.44644 2.60141 4.78223 3.01562 4.78223H11.0156C11.4298 4.78223 11.7656 4.44644 11.7656 4.03223C11.7656 3.61801 11.4298 3.28223 11.0156 3.28223H3.01562ZM2.26562 10.0322C2.26562 9.61801 2.60141 9.28223 3.01562 9.28223H11.0156C11.4298 9.28223 11.7656 9.61801 11.7656 10.0322C11.7656 10.4464 11.4298 10.7822 11.0156 10.7822H3.01562C2.60141 10.7822 2.26562 10.4464 2.26562 10.0322ZM3.01562 15.2822C2.60141 15.2822 2.26562 15.618 2.26562 16.0322C2.26562 16.4464 2.60141 16.7822 3.01562 16.7822H11.0156C11.4298 16.7822 11.7656 16.4464 11.7656 16.0322C11.7656 15.618 11.4298 15.2822 11.0156 15.2822H3.01562Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default MultiSelect
